import { info } from './InfoModal';
import { confirm } from './ConfirmModal';
import { asyncConfirm } from './AsyncConfirmModal';
import { CenterModal } from './CenterModal';
import { CommonModal } from './CommonModal';
import { Steps } from './Steps';

export const Modal = {
  info,
  confirm,
  asyncConfirm,
  CenterModal,
  Steps,
  CommonModal,
};

export * from './CenterModal';
export type { ModalStepProps } from './Steps';
export { InfoModal } from './InfoModal';

export default Modal;
